
import VueTypes from 'vue-types'

export default {
  props: {
    color: VueTypes.string.def('#212121'),
  },
}
